module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.1f023b34.ttf";